import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { apiHelper } from 'helpers';
import { caseStudyService } from 'services';
import { appSelectors } from 'redux/ducks/app';
import { ELSPageLoader } from 'components/common/els';
import AssignmentContent from 'components/common/assignment-content/AssignmentContent';

export const CaseStudyContent = (props: { courseId: string }) => {
  const [state, setState] = useState({caseStudies: [], isLoading: false});
  const {courseId} = props;

  useEffect(() => {
    const fetchCaseStudiesWithProductMapping = async () => {
      setState(prevState => ({...prevState, isLoading: true}));
      const { data: caseStudiesData } = await caseStudyService.getCaseStudies(courseId);
      setState({caseStudies: caseStudiesData, isLoading: false});
    };

    fetchCaseStudiesWithProductMapping().catch((err) => {
      apiHelper.showApiError(`can not get case studies ${err}`);
    });
  }, []);
  return (
    <div>
      {state.isLoading && <ELSPageLoader />}
      {!state.isLoading && state.caseStudies.length && <AssignmentContent content={state.caseStudies} {...props} />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  courseId: appSelectors.getCourseId(state),
});

export default connect(mapStateToProps)(CaseStudyContent);
